<template>
  <div>
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <div class="left">
            <div class="basic">
              <div class="nav_title">
                <span>招标信息</span>
              </div>
              <div class="message">
                <div class="form-item">
                  <div class="label">采购商名称：</div>
                  <div class="form-input">
                    {{ bidDetail.purchaser_name }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">项目编号：</div>
                  <div class="form-input">
                    {{ bidDetail.tender_no }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">发布时间：</div>
                  <div class="form-input">
                    {{ bidDetail.tender_time }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">距离结束：</div>
                  <div class="form-input">
                    还剩 {{ bidDetail.residue_time }}天
                  </div>
                </div>
              </div>
            </div>
            <div class="relation">
              <div class="nav_title">
                <span>公司基本信息</span>
              </div>
              <div class="message">
                <div class="form-item">
                  <div class="label">公司全称：</div>
                  <div class="form-input">
                    {{ bidDetail.company }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">公司地址：</div>
                  <div class="form-input">
                    {{ bidDetail.address }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">主营业务：</div>
                  <div class="form-input">
                    {{ bidDetail.business }}
                  </div>
                </div>
              </div>
            </div>
            <div class="relation">
              <div class="nav_title">
                <span>联系人信息</span>
              </div>
              <div class="message">
                <div class="form-item">
                  <div class="label">姓名：</div>
                  <div class="form-input">
                    {{ bidDetail.name }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">联系电话：</div>
                  <div class="form-input">
                    {{ bidDetail.mobile }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">职务：</div>
                  <div class="form-input">
                    {{ bidDetail.position }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">邮箱：</div>
                  <div class="form-input">
                    {{ bidDetail.email }}
                  </div>
                </div>
              </div>
            </div>
            <div class="other">
              <div class="nav_title">
                <span>其它信息</span>
              </div>
              <div class="message">
                <div class="form-item">
                  <div class="label">是否缴纳保证金：</div>
                  <div class="form-input">
                    <el-radio v-model="bidDetail.is_ensure" label="1" disabled
                      >已缴纳</el-radio
                    >
                    <el-radio v-model="bidDetail.is_ensure" label="0" disabled
                      >未缴纳</el-radio
                    >
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">上传附件：</div>
                  <div class="form-upload">
                    <div class="explain_down" v-if="bidDetail.file">
                      <img src="../../assets/images/wenjian.png" alt="" />
                      <p class="title">{{ bidDetail.file_name }}</p>
                      <p class="btn" @click.stop="downFile(bidDetail.file)">
                        下载
                      </p>
                    </div>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label label_ra">备注：</div>
                  <div class="form-input">
                    {{ bidDetail.remark }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>
<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "../user/components/user_index";
import Usernavleft from "../user/components/user_navleft";
export default {
  data() {
    return {
      bidId: this.$route.query.id,
      bidDetail: {
        address: "",
        business: "",
        company: "",
        email: "",
        file: "",
        file_name: "",
        file_prompt: "",
        is_ensure: "",
        mobile: "",
        name: "",
        position: "",
        purchaser_name: "",
        residue_time: "",
        tender_no: "",
        tender_time: "",
        title: "",
      },
    };
  },

  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  created() {
    this.getDetail();
  },
  mounted() {},
  methods: {
    getDetail() {
      let that = this;
      let params = {
        id: this.bidId,
      };
      this.$api
        .userBids(params)
        .then((res) => {
          if (res.code == 0) {
            that.bidDetail = res.data;
          } else {
            that.$message({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downFile(file) {
      if (file) {
        window.open("" + file);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ttshop_user {
  width: 100%;

  .ttshop_usercon {
    padding-top: 20px;
    padding-bottom: 60px;
    box-sizing: border-box;
    .ttshop_useright {
      width: 1000px;
      float: right;
      background: #fff;
      .left {
        margin: 0 22px;
        padding: 40px 0;
        .basic {
          //   padding-top: 43px;
          .nav_title {
            display: flex;
            align-items: center;
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              margin-left: 3px;
            }
            &::before {
              content: "";
              width: 4px;
              height: 16px;
              background: #dd2727;
              display: block;
            }
          }
          .message {
            .form-item {
              margin-top: 20px;
              width: 100%;
              .label {
                text-align: right;
                vertical-align: middle;
                float: left;
                font-size: 14px;
                color: #606266;
                line-height: 40px;
                padding: 0 12px 0 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 120px;
                &::before {
                  content: "*";
                  color: #f56c6c;
                  margin-right: 4px;
                }
              }
              .form-input {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 120px;
                width: calc(100% - 160px);
                // width: 300px;
              }
            }
          }
        }
        .relation {
          padding-top: 40px;
          .nav_title {
            display: flex;
            align-items: center;
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              margin-left: 3px;
            }
            &::before {
              content: "";
              width: 4px;
              height: 16px;
              background: #dd2727;
              display: block;
            }
          }
          .message {
            .form-item {
              margin-top: 20px;
              width: 100%;
              .label {
                text-align: right;
                vertical-align: middle;
                float: left;
                font-size: 14px;
                color: #606266;
                line-height: 40px;
                padding: 0 12px 0 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 120px;
                &::before {
                  content: "*";
                  color: #f56c6c;
                  margin-right: 4px;
                }
              }
              .form-input {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 120px;
                width: calc(100% - 160px);
                // width: 300px;
              }
            }
          }
        }
        .other {
          padding-top: 40px;
          .nav_title {
            display: flex;
            align-items: center;
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              margin-left: 3px;
            }
            &::before {
              content: "";
              width: 4px;
              height: 16px;
              background: #dd2727;
              display: block;
            }
          }
          .message {
            .form-item {
              margin-top: 20px;
              width: 100%;
              .label {
                text-align: right;
                vertical-align: middle;
                float: left;
                font-size: 14px;
                color: #606266;
                line-height: 40px;
                padding: 0 12px 0 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 160px;
                &::before {
                  content: "*";
                  color: #f56c6c;
                  margin-right: 4px;
                }
              }
              .label_ra {
                &::before {
                  content: "";
                }
              }
              .form-input {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 160px;
                width: calc(100% - 160px);
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                min-height: 40px;
                .toast {
                  margin-top: 12px;
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 17px;
                }
              }
              .form-upload {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 160px;
                min-width: 400px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                min-height: 40px;
                .explain_down {
                  display: flex;
                  align-items: center;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .title {
                    margin-left: 7px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #00a8ff;
                    line-height: 20px;
                  }
                  .btn {
                    cursor: pointer;
                    margin-left: 16px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #00a8ff;
                    line-height: 20px;
                  }
                }
                .upload_btn {
                  width: 124px;
                  height: 38px;
                  background: #f5f5f5;
                  border-radius: 2px;
                  border: 1px solid #e0e0e0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  line-height: 20px;
                }
                .toast {
                  margin-top: 12px;
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 17px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>